const USER_ACCOUNT_STATE_STATUSES = {
  NOT_AUTHENTICATED: 'NOT_AUTHENTICATED',
  REGISTERING: 'REGISTERING',
  AUTHENTICATING: 'AUTHENTICATING',
  LOGGING_IN: 'LOGGING_IN',
  LOGGING_OUT: 'LOGGING_OUT',
  REQUESTING_PASSWORD_RECOVERY: 'REQUESTING_PASSWORD_RECOVERY',
  RESETING_PASSWORD: 'RESETING_PASSWORD',
  AUTHENTICATED: 'AUTHENTICATED',
  CHANGING_PASSWORD: 'CHANGING_PASSWORD',
  UPDATING_EMAIL: 'UPDATING_EMAIL',
};

export { USER_ACCOUNT_STATE_STATUSES };
